import { useLocation, Navigate, useNavigate } from 'react-router-dom';
import { PaymentIntent } from '@stripe/stripe-js';
import { CheckoutPage } from '../Checkout/component';
import { parentRoutes } from 'src/navigators/routes/ParentRoutes';
import { Button, Image } from '@mantine/core';
import Icon from 'src/components/common/Icons/Icons/Icon';
import { useDispatch } from 'react-redux';
import { handleUserUpdate } from 'src/redux/redux-store';

export function CheckoutScreen() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  if (!state?.price) {
    return <Navigate to='/parent' replace />;
  }

  const handlePaymentSuccess = (paymentIntent: PaymentIntent) => {
    dispatch(handleUserUpdate() as any);
    navigate(parentRoutes.DASHBOARD);
  };

  return <CheckoutPage price={state.price} onSuccess={handlePaymentSuccess} />;
}
